import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useEffect } from 'react';
import {
  ApiReturnType,
  ExtendedRpcStatus,
  ExtendedUseQueryOptions,
  Fn,
} from '@shared-types/api';

export type QueryCommonOptions<T extends Fn> = {
  options?: any;
  useQueryOptions?: ExtendedUseQueryOptions<T>;
  onSuccess?: (data: ApiReturnType<T>) => void;
  onError?: (err: AxiosError<ExtendedRpcStatus>) => void;
};

interface Callbacks {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useQueryWithCallbacks = <
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
>(
  options: UseQueryOptions<TQueryFnData, TError, TData> & Callbacks,
) => {
  const result = useQuery(options);

  const { onSuccess, onError } = options;

  useEffect(() => {
    if (result.isSuccess && onSuccess) {
      onSuccess(result.data);
    }
  }, [result.isSuccess, result.data, onSuccess]);

  useEffect(() => {
    if (result.isError && onError) {
      onError(result.error);
    }
  }, [result.isError, result.error, onError]);

  return result;
};
